import { Flex } from "@similarweb/ui-components/foundations";

import { GranularitySwitcher } from "./GranularitySwitcher";
import { MetricDropdown } from "./MetricDropdown";

export const GrowthOverviewHeaderExtensions = () => (
    <Flex
        alignItems="center"
        gap="12px"
    >
        <GranularitySwitcher />
        <MetricDropdown />
    </Flex>
);
